import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments';
import { Consolidado } from '@shared/models/cierreTurno/Consolidado';
import { ResolucionMensual } from '@shared/models/cierreTurno/ResolucionMensual';
import { Justificacion } from '@shared/models/cierreTurno/Justificacion';
import { RespuestaAerovaleTrazabilidad } from '@shared/models/facturacion/RespuestaAerovaleTrazabilidad';

@Injectable({
  providedIn: 'root'
})
export class ReportesService
{
  cierreTurnoBase = environment.apiServer.cierreTurnoBaseUrl;
  stockBase = environment.apiServer.stockBaseUrl;
  facturacionBase = environment.apiServer.facturacionBaseUrl;
  despachoBase = environment.apiServer.baseUrl;
  private cierreURL = this.cierreTurnoBase + '/CierresTurnosV1/';
  private resolucionURL = this.cierreTurnoBase + '/ResolucionV1/';
  private reporteMovimientosURL = this.stockBase + '/ReportesV1/';
  private aerovalesV2Url = this.despachoBase + '/AerovalesV2/'
  baseUrl = environment.apiServer.reportesUrl;

  constructor(private http: HttpClient) {}

  obtenerReporteConsoldiado(codigoProducto:string, fdesde: string, fhasta:string): Observable<Consolidado[]> {
    return this.http.get<Consolidado[]>(this.cierreURL + 'Consolidado?codigoProducto='+codigoProducto + '&fechaDesde=' + fdesde + '&fechaHasta=' + fhasta);
  }

  obtenerResolucionMensual(codigoAeroplanta:string, fdesde: string, fhasta: string): Promise<ResolucionMensual> {
    return this.http.post<ResolucionMensual>(this.resolucionURL + `Resolucion?CodigoAeroplanta=${codigoAeroplanta}&fechaDesde=${fdesde}&fechaHasta=${fhasta}`, null).toPromise();
  }
  
  guardarResolucionMensual(codigoAeroplanta:string, fdesde: string, fhasta: string): Observable<ResolucionMensual[]> {
    return this.http.put<ResolucionMensual[]>(this.resolucionURL + `Resolucion?codigoAeroplanta=${codigoAeroplanta}&fechaDesde=${fdesde}&fechaHasta=${fhasta}`, null);
  }

  justificarRenglonResolucion(justificacion: Justificacion): Observable<Justificacion> {
    return this.http.put<Justificacion>(this.resolucionURL + 'Renglon', justificacion)
  }

  obtenerListaReporteMovimientos(ano: number) {
    return this.http.get(this.reporteMovimientosURL + `ReporteMovimientos?&ano=${ano}`);
  }

  obtenerAerovalesCompletosReporteTrazabilidad(fdesde?: string, fhasta?: string): Observable<RespuestaAerovaleTrazabilidad> {
    if(fdesde && fhasta) {
      return this.http.get<RespuestaAerovaleTrazabilidad>(this.aerovalesV2Url + 'AerovalesAnuladosYReemplazos?fechaDesde=' + fdesde + '&fechaHasta=' + fhasta)
    } else {
      return this.http.get<RespuestaAerovaleTrazabilidad>(this.aerovalesV2Url + 'AerovalesAnuladosYReemplazos')
    } 
  }

  obtenerLegajosAerovalesFacturas() {

  }
  obtenerLegajosAuditorias() {
    
  }
}